import React, { useContext, useState } from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import { Toast } from "../../../../hooks/toast";
import { useHistory } from "react-router";
import { DragMassUpload } from "./components/DragMassUpload";
import { ProductDraftContent } from "../../../../lib/interface/InterfaceProduct";
import { FirstValidation, SecondValidation } from "../../../../lib/ValidateNotEmpty";
import { ContextUser } from "../../../../context/ContextUser";
import { ProductDraft } from "src/components/custom/ProductDraft";
import { WriteFileExcel } from "src/lib/excel";
import { Badge, Box, Button, IndexTable, Layout, Page, Text, Thumbnail, Tooltip } from "@shopify/polaris";
import { PolarisCard } from "src/components/shopify/PolarisCard";
import { PolarisCategory } from "src/components/shopify/PolarisCategory";
import { ProductDraftBrandPicker } from "src/components/editor/ProductDraftBrandPicker";

const MUTATION = gql`
  mutation createMassUpload($products: JSON!, $supplierId: Int!, $reference: String) {
    createMassUpload(products: $products, supplierId: $supplierId, reference: $reference) {
      batchId
    }
  }
`;

const CHECK_SUPPLIER_CODE = gql`
  query merchantCheckSupplierList($supplier_code: [String]!) {
    merchantCheckSupplierList(supplier_code: $supplier_code)
  }
`;

export function MassProductScreen() {
  const [show, setShow] = useState(false);
  const [item, setItem] = useState([]);
  const { push } = useHistory();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [log, setLog] = useState("");
  const [category, setCategory] = useState(0);
  const [brand, setBrand] = useState(0);
  const context = useContext(ContextUser);
  const qrySuppliCode = useQuery(CHECK_SUPPLIER_CODE, {
    skip: data.length === 0,
    variables: {
      supplier_code: data.map((x) => x.supplier_code),
    },
    onCompleted: (res) => {
      if (!qrySuppliCode.loading) {
        setTimeout(() => {
          let strLog = "";

          strLog = `${strLog}<li class="text-muted pb-1 pt-1">Check empty data...</li>`;

          for (let i = 0; i < data.length; i++) {
            const str = CheckData(i + 1, data[i]);
            if (str) {
              strLog = `${strLog}${str}`;
            }
          }

          strLog = `${strLog}<li class="text-muted pb-1 pt-1">Check supplier code...</li>`;

          for (let i = 0; i < res.merchantCheckSupplierList.length; i++) {
            if (res.merchantCheckSupplierList[i].exist === true) {
              strLog = `${strLog}<li class="text-danger">[${data.findIndex((d) => d.supplier_code === res.merchantCheckSupplierList[i].code) + 1
                }] supplier code <code>${res.merchantCheckSupplierList[i].code}</code> already exist.</li>`;
            }
          }

          setLog(strLog);
        }, 1000);
      }
    },
  });

  const [merchantMassUpload] = useMutation(MUTATION, {
    onCompleted: (res) => {
      Toast.onShow("Mass upload was completed #" + res.createMassUpload.batchId, "success", "right");
      push("/product/mass/list");
    },
  });

  const handleClick = () => {
    if (data.length > 0) {
      merchantMassUpload({
        variables: {
          supplierId: Number(context.merchant.id),
          products: data,
          reference:
            "Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs.",
        },
      });
    }
  };

  // useEffect(() => {
  //   document.getElementById("DesktopMenu")!.className =
  //     "min-full-height menu-w color-scheme-dark color-style-bright menu-position-side menu-side-left menu-layout-mini sub-menu-style-over sub-menu-color-bright selected-menu-color-light menu-activated-on-hover menu-has-selected-link";
  // });

  // useEffect(() => {
  //   return () => {
  //     document.getElementById("DesktopMenu")!.className =
  //       "min-full-height menu-w color-scheme-light color-style-transparent menu-position-side menu-side-left menu-layout-compact sub-menu-style-over sub-menu-color-bright selected-menu-color-light menu-activated-on-hover menu-has-selected-link";
  //   };
  // });

  const downloadExcel = (e: boolean) => {
    setShow(e);
    if (e === false) {
      if (item.length > 0) {
        WriteFileExcel(item, context.merchant.id + "");
        setItem([]);
      }
    }
  };

  const downloadIntruction = () => {
    WriteFileExcel([], context.merchant.id + "", true);
  };

  return (
    <Page title="Data Log">
      <ProductDraft show={show} setShow={downloadExcel} items={item} setItems={setItem} />
      <Layout>
        <Layout.Section>
          <PolarisCard padding={"0"}>
            <Box padding={"0"}>
              <div className="form-secondary" style={{ maxHeight: 250, overflow: "auto" }}>
                <ul dangerouslySetInnerHTML={{ __html: log }} style={{ listStyle: "none", paddingLeft: 10 }}></ul>
              </div>
            </Box>
          </PolarisCard>
          <br />
          <PolarisCard>
            <Box>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Text as="h2" variant="headingSm">
                  Template Excel File & Instructions
                </Text>
                <div>
                  <Button onClick={downloadIntruction}>Download Template</Button>
                  <Button variant="primary" tone="success" onClick={() => downloadExcel(true)}>
                    Export product to excel
                  </Button>
                </div>
              </div>
              <br />
              <DragMassUpload
                onComplete={(e: ProductDraftContent[]) => {
                  setData(e);
                }}
                loading={loading}
                setLoading={setLoading}
              />
              <div className="mt-2" style={{ display: "flex", justifyContent: "end" }}>
                <Button variant="primary" tone="success" onClick={handleClick}>
                  Upload
                </Button>
              </div>
            </Box>
          </PolarisCard>
        </Layout.Section>
        <Layout.Section variant="oneThird">
          <PolarisCard>
            <Box>
              <input
                type="text"
                value={category}
                style={{ position: "fixed", top: -1000, left: -1000 }}
                id="categoryInput"
              />
              <PolarisCategory
                value={{ category_id: category }}
                onChange={async (v) => {
                  await setCategory(v.category_id || 0);
                  const copyText: any = document.getElementById("categoryInput");
                  copyText.select();
                  copyText.setSelectionRange(0, 99999);
                  document.execCommand("copy");
                  Toast.onShow(`Copied the category id #${copyText.value}`, "info", "right");
                }}
              />
            </Box>
          </PolarisCard>
          <br />
          <PolarisCard>
            <Box>
              <input type="text" value={brand} style={{ position: "fixed", top: -1000, left: -1000 }} id="brandInput" />
              <ProductDraftBrandPicker
                polaris
                value={brand + ""}
                onChange={async (e) => {
                  await setBrand(Number(e));
                  const copyText: any = document.getElementById("brandInput");
                  copyText.select();
                  copyText.setSelectionRange(0, 99999);
                  document.execCommand("copy");
                  Toast.onShow(`Copied the brand id #${copyText.value}`, "info", "right");
                }}
              />
            </Box>
          </PolarisCard>
        </Layout.Section>
        <Layout.Section variant="fullWidth">
          <PolarisCard padding={"0"}>
            <Box padding={"0"}>
              <IndexTable
                headings={[
                  { title: "No." },
                  { title: "Supplier Code" },
                  { title: "Main Image" },
                  { title: "Sale Price" },
                  { title: "Category" },
                  { title: "Brand" },
                  { title: "Title" },
                  { title: "Description" },
                  { title: "Colors" },
                  { title: "Sizes" },
                  { title: "Weight/Dimensions" },
                  { title: "Remote Stock" },
                  { title: "Consumable" },
                ]}
                itemCount={data.length || 0}
                loading={loading}
                selectable={false}
              >
                {data &&
                  data.map((x, i) => {
                    return (
                      <React.Fragment key={i}>
                        <IndexTable.Row rowType="data" key={i} position={i} id={i + ""}>
                          <IndexTable.Cell>
                            <small>{i + 1}</small>
                          </IndexTable.Cell>
                          <IndexTable.Cell>
                            <small>{x.supplier_code}</small>
                          </IndexTable.Cell>
                          <IndexTable.Cell>
                            <Thumbnail alt="" source={x.picture} />
                          </IndexTable.Cell>
                          <IndexTable.Cell>
                            <small>${x.saleprice}</small>
                          </IndexTable.Cell>
                          <IndexTable.Cell>
                            <small>{x.category_id}</small>
                          </IndexTable.Cell>
                          <IndexTable.Cell>
                            <small>{x.brand_id}</small>
                          </IndexTable.Cell>
                          <IndexTable.Cell>
                            <Tooltip content={JSON.parse(x.title).en}>
                              <div style={{ width: 150 }}>
                                <Text variant="bodySm" as="p" truncate>
                                  {JSON.parse(x.title).en}
                                </Text>
                              </div>
                            </Tooltip>
                          </IndexTable.Cell>
                          <IndexTable.Cell>
                            <Tooltip content={JSON.parse(x.description).en}>
                              <div style={{ width: 150 }}>
                                <Text variant="bodySm" as="p" truncate>
                                  {JSON.parse(x.description).en}
                                </Text>
                              </div>
                            </Tooltip>
                          </IndexTable.Cell>
                          <IndexTable.Cell>
                            <small>{x.colours}</small>
                          </IndexTable.Cell>
                          <IndexTable.Cell>
                            <small>{x.size}</small>
                          </IndexTable.Cell>
                          <IndexTable.Cell>
                            <small>
                              {x.weight}(Gram)/{x.dimension_width}CM x {x.dimension_height}CM x {x.dimension_length}CM
                            </small>
                          </IndexTable.Cell>
                          <IndexTable.Cell>
                            <Badge size="small" tone={x.remote_stock === "T" ? "success" : "critical"}>
                              {x.remote_stock === "T" ? "Yes" : "No"}
                            </Badge>
                          </IndexTable.Cell>
                          <IndexTable.Cell>
                            <Badge size="small" tone={x.consumable === "T" ? "success" : "critical"}>
                              {x.consumable === "T" ? "Yes" : "No"}
                            </Badge>
                          </IndexTable.Cell>
                        </IndexTable.Row>
                        <IndexTable.Row rowType="child" id={"addition_image"} position={Math.random() * 999}>
                          <IndexTable.Cell>
                            <small>Additional Images</small>
                          </IndexTable.Cell>
                          <IndexTable.Cell>
                            <div style={{ display: "flex" }}>
                              {x.images.map((img: any) => {
                                return (
                                  <div key={img.src}>
                                    <Thumbnail size="small" key={img.src} alt="" source={img.src} />;
                                  </div>
                                );
                              })}
                            </div>
                          </IndexTable.Cell>
                        </IndexTable.Row>
                      </React.Fragment>
                    );
                  })}
              </IndexTable>
            </Box>
          </PolarisCard>
        </Layout.Section>
      </Layout>
    </Page>
  );
}

function CheckData(index: number, data: any) {
  let str = "";
  const first = FirstValidation(data);
  const second = SecondValidation(data);

  if (first.status === false) {
    str = str + `<li class="text-danger">[${index}] ${first.error.name}.</li>`;
    return;
  }

  if (second.status === false) {
    str = str + `<li class="text-danger">[${index}] ${second.error.name}.</li>`;
    return;
  }

  return (str = str + `<li class="text-success">[${index}] data complete.</li>`);
}
